import React from 'react';

export const WalletIcon = () => (
  <svg width="28" height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M24.0974 23.1875H6.15992C5.44242 23.1875 4.77742 22.9075 4.26992 22.4C3.77992 21.8925 3.48242 21.21 3.48242 20.51V6.15998C3.48242 5.45998 3.76242 4.77748 4.26992 4.26998C4.77742 3.76248 5.44242 3.48248 6.15992 3.48248H21.4024C21.8924 3.48248 22.2774 3.86748 22.2774 4.35748C22.2774 4.84748 21.8924 5.23248 21.4024 5.23248H6.15992C5.91492 5.23248 5.68742 5.33748 5.51242 5.49498C5.33742 5.65248 5.24992 5.89748 5.24992 6.14248C5.24992 6.38748 5.35492 6.61498 5.51242 6.78998C5.66992 6.96498 5.91492 7.05248 6.15992 7.05248H24.0974C24.5699 7.05248 25.0249 7.24498 25.3574 7.57748C25.6899 7.90998 25.8824 8.36498 25.8824 8.81998V21.3675C25.8824 21.84 25.7074 22.2775 25.3749 22.61C25.0424 22.9425 24.5874 23.135 24.1149 23.135L24.0974 23.1875ZM5.24992 8.67998V20.5275C5.24992 20.7725 5.35492 21 5.51242 21.175C5.68742 21.35 5.91492 21.4375 6.15992 21.4375H24.0974V8.85498L6.15992 8.83748C5.84492 8.83748 5.52992 8.78498 5.24992 8.67998Z"
      fill="#3C3769"
    />
    <path
      d="M20.0721 16.03C20.8071 16.03 21.4196 15.435 21.4196 14.6825C21.4196 13.93 20.8246 13.335 20.0721 13.335C19.3196 13.335 18.7246 13.93 18.7246 14.6825C18.7246 15.435 19.3196 16.03 20.0721 16.03Z"
      fill="#3C3769"
    />
  </svg>
);



// WEBPACK FOOTER //
// ./src/assets/icons/Wallet.icon.jsx